import { useEffect } from "react";

// Gets information about the current URL
import { useLocation } from "react-router-dom";

// This component listens to the URL for a section name (like #about or #contact).
// When it finds one, it waits for the page to fully load,
// then automatically scrolls the user smoothly to that section.
//
// This component does not show anything on the screen — it only handles
// automatic scrolling behavior in the background.

function ScrollToHash() {

  // Current page URL info
  const location = useLocation();

  // Runs whenever the page URL changes
  useEffect(() => {

    // Gets the section name from the URL
    // Example: "#about" becomes "about"
    const hash = location.hash?.replace("#", "");

    // Stop if no section exists in the URL
    if (!hash) return;

    // Wait for the page to fully load first
    const t = setTimeout(() => {

      // Find the matching section on the page
      const el = document.getElementById(hash);

      // Smoothly scroll to that section
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 0);

    // Cleanup when leaving/changing page
    return () => clearTimeout(t);

  }, [location.pathname, location.hash]);

  // Return null because this component doesn’t display anything visually.
  return null;
}

export default ScrollToHash;